module.exports = __webpack_public_path__ + "media/cayman-machine-vision.47d0e260.mp4";